var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSharing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48579 14.26C5.56881 14.7865 3.16454 15.8616 4.6289 17.2068C5.34424 17.864 6.14093 18.334 7.14256 18.334H12.8581C13.8597 18.334 14.6564 17.864 15.3717 17.2068C16.8361 15.8616 14.4318 14.7865 13.5148 14.26C11.3646 13.0253 8.63608 13.0253 6.48579 14.26Z",
    stroke: "#898989",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9163 8.33268C12.9163 9.94352 11.6105 11.2493 9.99967 11.2493C8.38884 11.2493 7.08301 9.94352 7.08301 8.33268C7.08301 6.72185 8.38884 5.41602 9.99967 5.41602C11.6105 5.41602 12.9163 6.72185 12.9163 8.33268Z",
    stroke: "#898989",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37866 13.3327C1.92117 12.3047 1.66699 11.1668 1.66699 9.96985C1.66699 5.38376 5.39795 1.66602 10.0003 1.66602C14.6027 1.66602 18.3337 5.38376 18.3337 9.96985C18.3337 11.1668 18.0795 12.3047 17.622 13.3327",
    stroke: "#898989",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSharing);
export default __webpack_public_path__ + "static/media/user-sharing.a3f62f2eba08ea8f431168f5da5eec03.svg";
export { ForwardRef as ReactComponent };